// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";

/** 11908-字典项新增 POST /web/v1/dict/item/add */
export async function addDictItem(
  body: API.SwimDictItemAddVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/dict/item/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 11910-字典项删除 GET /web/v1/dict/item/delete/${param0} */
export async function deleteDictItem(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteDictItemParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/dict/item/delete/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 11907-字典项详情 GET /web/v1/dict/item/detail/${param0} */
export async function getDictItemDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getDictItemDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimDictItemDetailRespVo>(
    `/web/v1/dict/item/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 11906-字典项列表 GET /web/v1/dict/item/list */
export async function getDictItemList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getDictItemListParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimDictItemListRespVo>(
    "/web/v1/dict/item/list",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 11909-字典项修改 POST /web/v1/dict/item/update */
export async function updateDictItem(
  body: API.SwimDictItemUpdateVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/dict/item/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 11903-字典类型新增 POST /web/v1/dict/type/add */
export async function addDictType(
  body: API.SwimDictTypeAddVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/dict/type/add", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}

/** 11905-字典类型删除 GET /web/v1/dict/type/delete/${param0} */
export async function deleteDictType(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.deleteDictTypeParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOBoolean>(`/web/v1/dict/type/delete/${param0}`, {
    method: "GET",
    params: { ...queryParams },
    ...(options || {}),
  });
}

/** 11902-字典类型详情 GET /web/v1/dict/type/detail/${param0} */
export async function getDictTypeDetail(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getDictTypeDetailParams,
  options?: { [key: string]: any }
) {
  const { id: param0, ...queryParams } = params;
  return request<API.YmResultVOSwimDictTypeDetailRespVo>(
    `/web/v1/dict/type/detail/${param0}`,
    {
      method: "GET",
      params: { ...queryParams },
      ...(options || {}),
    }
  );
}

/** 11901-字典类型列表 GET /web/v1/dict/type/list */
export async function getDictTypeList(
  // 叠加生成的Param类型 (非body参数swagger默认没有生成对象)
  params: API.getDictTypeListParams,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOListSwimDictTypeListRespVo>(
    "/web/v1/dict/type/list",
    {
      method: "GET",
      params: {
        ...params,
      },
      ...(options || {}),
    }
  );
}

/** 11904-字典类型修改 POST /web/v1/dict/type/update */
export async function updateDictType(
  body: API.SwimDictTypeUpdateVo,
  options?: { [key: string]: any }
) {
  return request<API.YmResultVOBoolean>("/web/v1/dict/type/update", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    data: body,
    ...(options || {}),
  });
}
